
import { computed, defineComponent } from "vue";
import { RouterView, useRoute } from "vue-router";

import Layout from "@/components/layout/index.vue";

export default defineComponent({
  name: "App",
  setup() {
    const route = useRoute();

    // xiyou 模块（挂在根路径）不套站点全局 layout；官网页面维持原有我是谜导航/页脚。
    // main.ts 在 router.isReady() 之后才挂载，首帧拿到的就是已解析路由，无需按路径猜测。
    const standalone = computed(() => route.meta.standalone === true);

    return () => (standalone.value ? <RouterView /> : <Layout />);
  },
});
